import React from 'react';
import { Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import './features-carousel.scss';
import Flickity from 'react-flickity-component';

const FeaturesCarousel = () => {
  const flickityOptions = {
    autoPlay: false,
    pauseAutoPlayOnHover: true,
    wrapAround: true,
    adaptiveHeight: true,
    draggable: true,
    contain: true,
    groupCells: true,
    pageDots: false,
  };
  return (
    <div>
      <Flickity
        className={'flickity-enabled'} // default ''
        elementType={'div'} // default 'div'
        options={flickityOptions} // takes flickity options {}
        disableImagesLoaded={true} // default false
        reloadOnUpdate // default false
        static // default false
      >
        <div className="card">
          <div className="App_carousel_text_box">
            <Typography variant="h5">Staking Vaults</Typography>
            <Typography variant="h6">
              Build cover capacity &amp; earn rewards by staking in one of
              iTrust’s risk-managed staking vaults.
            </Typography>
            <Button
              target="_blank"
              href="https://app.itrust.finance/"
              className="App_carousel_buttons_a"
            >
              Staking Vault
            </Button>
          </div>
          <div className="icon icon_a_bg"></div>
        </div>
        <div className="card">
          <div className="App_carousel_text_box">
            <Typography variant="h5">Coral (LP) Farming</Typography>
            <Typography variant="h6">
              Build liquidity for the network by participating in our innovative
              LP rewards programs.
            </Typography>
            <Button
              target="_blank"
              href="https://itrust.finance/liquidity/#/"
              className="App_carousel_buttons_a"
            >
              Coral Farming
            </Button>
          </div>
          <div className="icon icon_b_bg"></div>
        </div>
        <div className="card">
          <div className="App_carousel_text_box">
            <Typography variant="h5">Community Reef</Typography>
            <Typography variant="h6">
              Join the community, learn how you can contribute to the DAO, and
              help maintain the ecosystem.
            </Typography>
            <Button
              target="_blank"
              href="https://discord.com/invite/pTre3yYu78"
              className="App_carousel_buttons_a"
            >
              Community Reef
            </Button>
          </div>
          <div className="icon icon_c_bg"></div>
        </div>
        <div className="card">
          <div className="App_carousel_text_box">
            <Typography variant="h5">Ship“REKT” Market</Typography>
            <Typography variant="h6">
              The Ship“REKT” Prediction Market: Quadratic voting, meritocratic
              ratings, and token rewards.
            </Typography>
            <Button href="#" disabled={true} className="App_carousel_buttons_a">
              Coming Soon
            </Button>
          </div>
          <div className="icon icon_d_bg"></div>
        </div>
        <div className="card">
          <div className="App_carousel_text_box">
            <Typography variant="h5">Staking Vaults</Typography>
            <Typography variant="h6">
              Build cover capacity &amp; earn rewards by staking in one of
              iTrust’s risk-managed staking vaults.
            </Typography>
            <Button
              target="_blank"
              href="https://app.itrust.finance/"
              className="App_carousel_buttons_a"
            >
              Staking Vault
            </Button>
          </div>
          <div className="icon icon_a_bg"></div>
        </div>
        <div className="card">
          <div className="App_carousel_text_box">
            <Typography variant="h5">Coral (LP) Farming</Typography>
            <Typography variant="h6">
              Build liquidity for the network by participating in our innovative
              LP rewards programs.
            </Typography>
            <Button
              target="_blank"
              href="https://itrust.finance/liquidity/#/"
              className="App_carousel_buttons_a"
            >
              Coral Farming
            </Button>
          </div>
          <div className="icon icon_b_bg"></div>
        </div>
        <div className="card">
          <div className="App_carousel_text_box">
            <Typography variant="h5">Community Reef</Typography>
            <Typography variant="h6">
              Join the community, learn how you can contribute to the DAO, and
              help maintain the ecosystem.
            </Typography>
            <Button
              target="_blank"
              href="https://discord.com/invite/pTre3yYu78"
              className="App_carousel_buttons_a"
            >
              Community Reef
            </Button>
          </div>
          <div className="icon icon_c_bg"></div>
        </div>
        <div className="card">
          <div className="App_carousel_text_box">
            <Typography variant="h5">Ship“REKT” Market</Typography>
            <Typography variant="h6">
              The Ship“REKT” Prediction Market: Quadratic voting, meritocratic
              ratings, and token rewards.
            </Typography>
            <Button href="#" disabled={true} className="App_carousel_buttons_a">
              Coming Soon
            </Button>
          </div>
          <div className="icon icon_d_bg"></div>
        </div>
      </Flickity>
    </div>
  );
};

export default FeaturesCarousel;
